/**
 * PartnerRecurringRevenueBanner — global banner pinned to the top of every
 * Partner Dashboard page. Reminds partners of the 10% recurring revenue
 * model and reinforces that Stripe Connect handles every payout
 * automatically. Premium black + gold treatment to match the portal.
 */
import React from 'react';

const PartnerRecurringRevenueBanner = () => {
  return (
    <div
      data-testid="partner-recurring-revenue-banner"
      className="mb-6 rounded-2xl border border-gold-500/40 bg-gradient-to-r from-gold-500/[0.10] via-amber-500/[0.06] to-gold-500/[0.10] px-5 py-4 sm:px-6 sm:py-5 relative overflow-hidden"
    >
      {/* Subtle background shimmer for premium feel */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 opacity-30"
        style={{
          background:
            'radial-gradient(circle at 18% 50%, rgba(251,191,36,0.18) 0%, transparent 60%)',
        }}
      />
      <div className="relative flex items-start sm:items-center gap-3 sm:gap-4">
        <div className="flex-shrink-0 inline-flex items-center justify-center w-10 h-10 sm:w-11 sm:h-11 rounded-xl bg-gold-500/20 border border-gold-500/40 text-xl sm:text-2xl">
          <span role="img" aria-label="money">💰</span>
        </div>
        <div className="min-w-0">
          <h3
            data-testid="partner-banner-title"
            className="text-[14px] sm:text-[15.5px] font-extrabold text-gold-100 tracking-tight leading-snug"
          >
            Earn 10% Monthly Recurring Revenue
          </h3>
          <p
            data-testid="partner-banner-body"
            className="mt-1 text-[12.5px] sm:text-[13px] text-white/75 leading-relaxed"
          >
            Every active member restaurant you refer generates recurring monthly income for your organization. Payments are sent automatically through Stripe Connect.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PartnerRecurringRevenueBanner;
